import { render, staticRenderFns } from "./StudyExperience.vue?vue&type=template&id=3a8a7506&scoped=true"
import script from "./StudyExperience.vue?vue&type=script&setup=true&lang=js"
export * from "./StudyExperience.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StudyExperience.vue?vue&type=style&index=0&id=3a8a7506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a7506",
  null
  
)

export default component.exports